import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "textPrimaryParagraph textBold",
  style: {"color":"#E6A23C"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode("Habilitación exitosa "),
      _createVNode(_component_font_awesome_icon, { icon: "check-circle" })
    ]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ], 64))
}